/**
 * Change notifications for the review DB. Writes happen from background work (downloads,
 * sync) as well as from the UI; listeners just re-read the DB. Bursts are coalesced, and
 * other tabs are told through a BroadcastChannel.
 */

type Listener = () => void;

const listeners = new Set<Listener>();
let scheduled = false;

const channel: BroadcastChannel | null =
    typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('print-file-review') : null;

const fire = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
        scheduled = false;
        listeners.forEach((l) => l());
    }, 50);
};

channel?.addEventListener('message', fire);

export const subscribeReviewStore = (listener: Listener) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const notifyReviewStore = () => {
    fire();
    channel?.postMessage('changed');
};
